var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gap-events"},[_c('event-teaser',{attrs:{"type":_vm.type,"date":_vm.gapDate,"position":_vm.position,"extended":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }